import React from 'react'
import { Link } from 'react-router-dom'

const links = () => {
  return (
    <div className='links_Wrapper'>
        <ul>
            <Link to='#'><li>Sustainability</li></Link>
            <Link to='story'><li>Story</li></Link>
            <Link to='#'><li>Sell on Kaay</li></Link>
            <Link to='brandmap'><li>Brand Sitemap</li></Link>
            <Link to='sellingmap'><li>Selling Sitemap</li></Link>
            <Link to='#'><li>Cookies</li></Link>
            <Link to='/policies'><li>Policies</li></Link>
            <Link to='/privacypolicy'><li>Privacy policy</li></Link>
            <Link to='/faq'><li>FAQs</li></Link>
        </ul>
    </div>
  )
}

export default links
